"use strict";
import i from "./index.es119.js";
import l from "./index.es330.js";
function s(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function m(e, r, n) {
  if (!r)
    return e;
  const c = n && n.encode || s;
  i.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let t;
  if (o ? t = o(r, n) : t = i.isURLSearchParams(r) ? r.toString() : new l(r, n).toString(c), t) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + t;
  }
  return e;
}
export {
  m as default
};
//# sourceMappingURL=index.es235.js.map
